module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow.gray-86cd80b4ba6c30cb2725558548fac746.svg";